import { Component } from '@opten/compiler/metadata/component';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

declare const tns: any;

@Component({ className: 'js-detail-slider' })
export class DetailSliderCustom {
	private slider;
	private sliderRef;
	private customIndexChange = false;
	private customRefIndexChange = false;

	constructor(public element: HTMLElement) {
		const slidesRef = element.querySelector('.js-slides-ref');
		this.slider = tns({
			container: element.querySelector('.js-slides'),
			controls: false,
			nav: false,
			mouseDrag: true,
			loop: false,
			autoHeight: true,
			items: 1,
			gutter: 0,
			responsive: {
				1460: {
					items: 5
				},
				992: {
					items: 3
				},
				768: {
					items: 2,
					gutter: 15
				}
			}
		});
		if (slidesRef !== null && slidesRef !== undefined) {
			this.sliderRef = tns({
				arrowKeys: true,
				container: element.querySelector('.js-slides-ref'),
				controlsContainer: element.querySelector('.js-arrows'),
				nav: false,
				mouseDrag: true,
				loop: false,
				autoHeight: true
			});
			Array.from(this.slider.getInfo().slideItems).forEach(
				(slide: any, index) => {
					slide.addEventListener('click', () => {
						this.sliderRef.goTo(index);
						// this.activateSlider();
					});
				}
			);
			this.slider.events.on("indexChanged", (evt) => {
				this.customIndexChange = true;
				if (this.customRefIndexChange == false) {
					const indexToGoTo = this.getIndexToGoTo(evt);
					if (indexToGoTo) {
						this.sliderRef.goTo(indexToGoTo);
					}
					this.customIndexChange = false;
					this.customRefIndexChange = false;
				}
			});
			this.slider.events.on('newBreakpointEnd', evt => {
				setTimeout(() => {
					this.slider.updateSliderHeight();
					this.slider.goTo(0);
				}, 500);
			});

			if (this.sliderRef !== null && this.sliderRef !== undefined) {
				this.sliderRef.events.on('indexChanged', evt => {
					this.customRefIndexChange = true;
					if (this.customIndexChange == false) {
						const indexToGoTo = this.getIndexToGoTo(evt);
						if (indexToGoTo) {
							this.slider.goTo(indexToGoTo);
						}
						this.customIndexChange = false;
						this.customRefIndexChange = false;
					}
				});
				this.sliderRef.events.on('transitionEnd', evt => {
					this.activateSlider();
				});
			}
		}

		const firstSlide = element.getElementsByClassName(
			'js-slide'
		)[0] as HTMLElement;
		addClass(firstSlide, 'is-active');

		const arrows = Array.from(
			element.getElementsByClassName('js-slider-arrow')
		);
		arrows.forEach(arrow => {
			element.addEventListener('click', () => {
				// this.activateSlider();
			});
		});
	}

	private getIndexToGoTo(evt) {
		const prevIndex = evt.indexCached ? evt.indexCached : 0;
		if (evt.index > prevIndex) {
			return 'next';
		}
		if (evt.index < prevIndex) {
			return 'prev';
		}
		return undefined;
	}

	private activateSlider() {
		const textBox = Array.from(
			this.element.getElementsByClassName('js-slide-box')
		);
		let object = [];
		textBox.forEach(element => {
			if (hasClass(element, 'tns-slide-active')) {
				object.push(1);
			} else {
				object.push(0);
			}
		});
		const slides = Array.from(
			this.element.getElementsByClassName('js-slide')
		);
		let i = 0;
		slides.forEach(element => {
			if (object[i] === 1) {
				addClass(element, 'is-active');
			} else {
				removeClass(element, 'is-active');
			}
			i++;
		});
	}
}
